import { FlowActions, FlowRoute, FlowRouteCategory } from '@eneco/flows/types';

import {
  msciAuthenticateByAddress,
  msciAuthenticateByEmail,
  msciAuthenticateByKVK,
  resetSolarPanelsOutput,
  resetUsageValues,
  setUsageKnown,
} from '../actions';
import { FlowContextSme } from '../context';
import { shouldSkipWhenNoElectricity, shouldSkipWhenOnlyWarmth } from '../skippingRules';
import {
  AddressDetailsStep,
  AddressStep,
  CompanyDetailsStep,
  DeliveryDateStep,
  EmployeeCountStep,
  EnergyChoiceStep,
  ExistingOrNewCustomerStep,
  OfferStep,
  RevenueStep,
  SolarPanelsStep,
  SummaryStep,
  UsageStep,
} from '../steps';

export const initialContext: FlowContextSme = { isSME: true };

export const routes: FlowRoute<FlowContextSme>[] = [
  {
    id: 'ADDRESS',
    path: '/adres/',
    category: FlowRouteCategory.Calculation,
    component: AddressStep,
    skippingFields: ['postalCode', 'houseNumber'],
  },
  {
    id: 'EMPLOYEE_COUNT',
    path: '/medewerkers/',
    category: FlowRouteCategory.Calculation,
    component: EmployeeCountStep,
  },
  { id: 'REVENUE', path: '/omzet/', category: FlowRouteCategory.Calculation, component: RevenueStep },
  {
    id: 'ADDRESS_DETAILS',
    path: '/adres/details/',
    category: FlowRouteCategory.Calculation,
    component: AddressDetailsStep,
    actions: ['msciAuthenticateByAddress'],
  },
  {
    id: 'ENERGY_CHOICE',
    path: '/energiekeuze/',
    category: FlowRouteCategory.Calculation,
    component: EnergyChoiceStep,
    actions: ['resetUsageValues'],
  },
  {
    id: 'CUSTOMER_INFORMATION',
    path: '/leveringgegevens/',
    category: FlowRouteCategory.Calculation,
    component: ExistingOrNewCustomerStep,
  },
  {
    id: 'USAGE',
    path: '/verbruik/',
    category: FlowRouteCategory.Calculation,
    component: UsageStep,
    actions: ['setUsageKnown'],
  },
  {
    id: 'SOLAR_PANELS',
    path: '/zonnepanelen/',
    category: FlowRouteCategory.Calculation,
    component: SolarPanelsStep,
    actions: ['resetSolarPanelsOutput'],
    skippingRules: [shouldSkipWhenNoElectricity],
  },
  {
    id: 'OFFER',
    path: '/productkeuze/looptijd/',
    category: FlowRouteCategory.Calculation,
    component: OfferStep,
    skippingRules: [shouldSkipWhenOnlyWarmth],
  },
  {
    id: 'DELIVERY_DATE',
    path: '/je-gegevens/start-leverdatum/',
    category: FlowRouteCategory.Details,
    component: DeliveryDateStep,
  },
  {
    id: 'COMPANY_DETAILS',
    path: '/je-gegevens/bedrijfsgegevens/',
    category: FlowRouteCategory.Details,
    component: CompanyDetailsStep,
    actions: ['msciAuthenticateByEmail'],
  },
  {
    id: 'SUMMARY',
    path: '/je-gegevens/controle-keuze/',
    category: FlowRouteCategory.Summary,
    component: SummaryStep,
    actions: ['msciAuthenticateByKVK'],
  },
];

export const actions: FlowActions<FlowContextSme> = {
  setUsageKnown,
  resetUsageValues,
  resetSolarPanelsOutput,
  msciAuthenticateByEmail,
  msciAuthenticateByAddress,
  msciAuthenticateByKVK,
};
